
import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

interface ShareFormProps {
  onSubmit: (e: React.FormEvent) => void;
  email: string;
  setEmail: (email: string) => void;
  error: string | null;
  isSubmitting: boolean;
  onClose: () => void;
  existingShares: any[];
}

const ShareForm: React.FC<ShareFormProps> = ({
  onSubmit,
  email,
  setEmail,
  error,
  isSubmitting,
  onClose,
  existingShares = []
}) => {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="email">E-post</Label>
        <Input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="användare@exempel.com"
          disabled={isSubmitting}
          required
        />
        <p className="text-xs text-slate-500">
          Användaren kommer att kunna se och arbeta med innehållet i denna mapp.
        </p>
      </div>

      {error && (
        <Alert variant="destructive">
          <AlertTriangle className="h-4 w-4" />
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}

      {existingShares.length > 0 && (
        <div className="mt-4">
          <h3 className="text-sm font-medium mb-2">Delad med:</h3>
          <ul className="space-y-1">
            {existingShares.map((share) => (
              <li key={share.id} className="text-xs text-slate-600 flex items-center gap-2">
                <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                {share.shared_with_email}
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="flex justify-end gap-2 pt-2">
        <Button
          type="button"
          variant="outline"
          onClick={onClose}
          disabled={isSubmitting}
        >
          Avbryt
        </Button>
        <Button type="submit" disabled={isSubmitting || !email.trim()}>
          {isSubmitting ? "Delar..." : "Dela mapp"}
        </Button>
      </div>
    </form>
  );
};

export default ShareForm;
